import { lazy } from 'react';
import WithSuspense from 'Hocs/withSuspense';

const AnalyticsHead = lazy(() => import('Components/AnalyticsHead'));

export const LazyAnalyticsHead = WithSuspense(AnalyticsHead);
